import React from 'react';
import { Link } from 'react-router-dom';
import { GetSummaryRuleOptionName } from '../../../utils/UtilFunction';
import * as Const from '../../../utils/Const';

interface SelfStudyAdminSummaryTableProps {
  data?: any[];
  summaryItem: number;
  startDateTime: Date;
  toDateTime: Date;
  endType: string[];
}

export const SelfStudyAdminSummaryTable: React.FC<SelfStudyAdminSummaryTableProps> = ({
  data,
  summaryItem,
  startDateTime,
  toDateTime,
  endType,
}) => {
  if (!data || data.length === 0) return <></>;

  const header = [
    GetSummaryRuleOptionName(summaryItem),
    // 'シナリオ',
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
    '教材',
  ];

  const columns = [
    'summary_item',
    // 'label',
    // 'material_name',
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];

  // 1月〜12月のインデックス範囲（header/columns共通）
  const monthStart = 2;
  const monthEnd = 13;
  return (
    <div className="overflow-y-auto w-full h-[400px] mx-4">
      <table className="w-full border-collapse">
        <thead className="sticky top-0">
          <tr>
            {header.map((h) => (
              <th key={h} className="border border-gray-300 p-2 bg-[#e0e0e0]">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {columns.map((col, i) => (
                // 数値項目は右寄せ
                <td
                  key={col}
                  className={`border border-gray-300 p-2 ${
                    i >= monthStart && i <= monthEnd ? 'text-right' : ''
                  }`}
                >
                  {row[col]}
                </td>
              ))}
              <td className="border border-gray-300 p-2">
                <Link
                  to={`/dashboard_selfstudy_admin_detail?orgId=${
                    row.org_id
                  }&summaryItem=${summaryItem}&startDateTime=${startDateTime}&toDateTime=${toDateTime}&endType=${endType.join(
                    ','
                  )}&summaryRuleName=${row.summary_item}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  {Const.LabelMaterialName}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
